module.exports = __webpack_public_path__ + "img/p3_r.c0308f77.jpg";